import { Link } from 'react-router-dom';

interface CategoryTagProps {
  slug: string;
  name: string;
  icon: string;
  active?: boolean;
  variant?: 'pill' | 'card';
}

export default function CategoryTag({ slug, name, icon, active, variant = 'pill' }: CategoryTagProps) {
  if (variant === 'card') {
    return (
      <Link
        to={`/category/${slug}`}
        className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50 hover:bg-primary-50 transition-all duration-200 cursor-pointer group"
      >
        <div className={`w-12 h-12 flex items-center justify-center rounded-full transition-colors ${
          active ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600 group-hover:bg-primary-100 group-hover:text-primary-500'
        }`}>
          <i className={`${icon} text-lg`}></i>
        </div>
        <span className={`text-xs font-medium transition-colors ${
          active ? 'text-primary-600' : 'text-foreground-700'
        }`}>
          {name}
        </span>
      </Link>
    );
  }

  return (
    <Link
      to={`/category/${slug}`}
      className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
        active
          ? 'bg-primary-500 text-background-50 shadow-sm'
          : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-500'
      }`}
    >
      <i className={`${icon} text-sm`}></i>
      {name}
    </Link>
  );
}